import { WIS_RPC_COMMANDS, WIS_RPC_MESSAGE, WIS_PRESENCE } from '../constants';

import executeWisRpc from './executeWisRpc';

export default function sendWisHeadsetPresence(socket, isHangup = false) {

    const rpcCommand = {
        message: WIS_RPC_MESSAGE.HEADSET,
        msgdata: {
            command: WIS_RPC_COMMANDS.SET_PRESENCE,
            presence: {
                type: WIS_PRESENCE.AVAILABLE,
                show: isHangup ? WIS_PRESENCE.AVAILABLE : WIS_PRESENCE.DND,
                extra: {
                    'device-show': isHangup ? WIS_PRESENCE.REGISTERED : WIS_PRESENCE.TALKING,
                    call: {
                        name: '',
                        number: ''
                    },
                    location: {
                        address: '',
                        lat: '',
                        lng: ''
                    }
                },
                status: '',
                until: ''
            }
        }
    };

    executeWisRpc(socket, rpcCommand);
}
